import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/common/Layout';
import MapView from './components/map/MapView';
import ProviderManager from './components/admin/ProviderManager';
import LandingPage from './pages/LandingPage'; // 
import LoginPage from './pages/LoginPage';
import PrivateRoute from './components/common/PrivateRoute';
import RegisterPage from './pages/RegisterPage';
import ProviderDashboard from './pages/ProviderDashboard';
import EditListingPage from './pages/EditListingPage';
import AdminProviderDetailPage from './pages/AdminProviderDetailPage';
import MyListingsPage from './pages/MyListingsPage';
import EventsPage from './pages/EventsPage'; // Public Calendar
import ManageEventsPage from './pages/ManageEventsPage'; // Private Form
import FavoritesPage from './pages/FavoritesPage'; // Favorites Page
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmail from './pages/VerifyEmail';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import HistoryPage from './pages/HistoryPage'; // 
import CookieBanner from './components/common/CookieBanner'; // Cookie Consent Banner
import ProfilePage from './pages/ProfilePage'; // Import profile page
import IOSInstallPrompt from './components/common/IOSInstallPrompt';
import ScrollToTop from './components/common/ScrollToTop';
import ProviderAnalytics from './pages/ProviderAnalytics'; // Provider analytics page
import NotFoundPage from './pages/NotFoundPage';
import { Toaster } from 'react-hot-toast';

function App() {

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ScrollToTop />
      <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
      <CookieBanner />
      <Routes>
        
        {/* Route 1: Landing Page (New Home) */}
        <Route 
          path="/" 
          element={
            <Layout>
             <IOSInstallPrompt />
              <LandingPage />
            </Layout>
          } 
        />

        {/* Route 2: The Map (Moved to /map) */}
        <Route 
          path="/map" 
          element={
            <Layout noPadding={true}>
              <MapView />
            </Layout>
          } 
        />

        {/* Public Registration Page */}
        <Route path="/register" element={<Layout><RegisterPage /></Layout>} />

        {/* PROTECTED: Only providers can see this */}
        <Route 
          path="/provider/dashboard" 
          element={
            <PrivateRoute role="provider">
              <Layout>
                <ProviderDashboard />
              </Layout>
            </PrivateRoute>
          } 
        />

        {/* Admin Routes */}
        <Route path="/login" element={<Layout><LoginPage /></Layout>} />

        {/* PROTECTED ADMIN ROUTE */}
        <Route
          path="/admin/providers"
          element={
            <PrivateRoute role="admin">
              <Layout>
                <ProviderManager />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* PROTECTED ADMIN ROUTE — single provider detail */}
        <Route
          path="/admin/providers/:id"
          element={
            <PrivateRoute role="admin">
              <Layout>
                <AdminProviderDetailPage />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* PROTECTED ADMIN ROUTE */}
        <Route
          path="/admin/users/:id" 
          element={
            <PrivateRoute role="admin">
              <Layout>
                <ProfilePage />
              </Layout>
            </PrivateRoute>
          } 
        />

        <Route path="/provider/edit-listing" element={
          <PrivateRoute role="provider">
            <Layout>
              <EditListingPage />
            </Layout>
        </PrivateRoute>
        } 
      />

        <Route 
          path="/provider/my-listings" 
          element={<PrivateRoute role="provider"><Layout><MyListingsPage /></Layout></PrivateRoute>} 
        />

        {/* EDIT: Update Existing (With ID) */}
        <Route 
          path="/provider/edit-listing/:id" 
          element={<PrivateRoute role="provider"><Layout><EditListingPage /></Layout></PrivateRoute>} 
        />

        {/* Public: Community Calendar */}
        <Route 
          path="/events" 
          element={<Layout><EventsPage /></Layout>} 
        />

        {/* Private: Provider Event Creation */}
        <Route 
          path="/provider/manage-events" 
          element={
            <PrivateRoute role="provider">
              <Layout>
                <ManageEventsPage />
              </Layout>
            </PrivateRoute>
          } 
        />


        {/* Provider analytics */}
        <Route
          path="/provider/analytics"
          element={
            <PrivateRoute role="provider">
              <Layout>
                <ProviderAnalytics />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* End user dashboard  */}
        <Route 
          path="/user/dashboard" 
          element={
            <PrivateRoute role="user">
              <Layout>
                <FavoritesPage />
              </Layout>
            </PrivateRoute>
          } 
        />


        <Route 
          path="/admin/edit-listing/:id" 
          element={
            <PrivateRoute role="admin">
              <Layout>
                {/* We reuse the same component! */}
                <EditListingPage />
              </Layout>
            </PrivateRoute>
          } 
        />

        {/* Protect the profile route so only logged-in users can see it */}
        <Route 
          path="/profile" 
          element={
            <PrivateRoute>
              <Layout>
                <ProfilePage />
              </Layout>
            </PrivateRoute>
          } 
        />

        <Route path="/forgot-password" element={<Layout><ForgotPasswordPage /></Layout>} />
        <Route path="/reset-password/:resetToken" element={<Layout><ResetPasswordPage /></Layout>} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/terms-of-service" element={<Layout><TermsPage /></Layout>} />
        <Route path="/privacy" element={<Layout><PrivacyPolicyPage /></Layout>} />
        <Route path="/history" element={<Layout><HistoryPage /></Layout>} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />

        {/* 404 Catch-all */}
        <Route path="*" element={<Layout><NotFoundPage /></Layout>} />

        </Routes>

    </BrowserRouter>
  );
}

export default App;
